/*
* @NOTE:
 Matches an entire string that looks like: Country Name +Code

Details:
 Starts at the beginning and ends at the end (no extra characters allowed).
 Country name part (Group 1): one or more letters (including accented), spaces, apostrophes, parentheses, commas, or hyphens.
 Exactly one space.
 A literal plus sign `+`.
 Country calling code (Group 2): 1 to 3 digits.
Examples: France +33, Côte d'Ivoire +225, United States +1
Rejects: France+33, France  +33 (double space), France +3311 (too many digits).
* */
export const countryName_countryCodeRegex = new RegExp(
  /^([A-Za-zÀ-ž\s'’(),.-]+)\s\+(\d{1,4})$/,
);

/*
* @NOTE:
* Matches an entire string shaped like: one or more letters/spaces, at least one whitespace gap, a plus sign, then one or more digits.
  Regex parts:
  *  ^ and $: anchor to start/end (no extra chars).
  * [A-Za-z ]+: at least one ASCII letter or space (no accents, hyphens, apostrophes).
  * \s+: one or more whitespace characters (could be tabs, not just a single space).
  * \+: literal plus.
  * [0-9]+: one or more digits (length not limited).
Accepts: France +33, United States   +1 (multiple spaces), ABC +9999
Rejects: France+33 (missing whitespace), France  + (no digits), Côte d'Ivoire +225 (accent), France- Test +44 (hyphen).
* */
export const countryCodeWithAlphabetsRegex = new RegExp(
  /^[A-Za-z ]+\s+\+[0-9]+$/,
);

/*
* @NOTE:
* Regex: `/^\+(\d{1,4})/`

Explanation:
* `^` asserts start of the string.
* `\+` matches a literal plus sign.
* `(\d{1,4})` captures between 1 and 4 digits (0–9) into Group 1.
* No `$` anchor, so it matches only the leading segment; extra characters after the digits are allowed.

Matches (group 1 shown):
* `+1` → `1`
* `+1234abc` → `1234`
* `+987` → `987`

Does not match:
* `1` (no plus)
* `++12`
* `+` (no digits)

If you want to enforce the entire string, use: `/^\+(\d{1,4})$/`.
* */
export const countryCodeRegexNumericRegex = new RegExp(/^\+(\d{1,4})/);

/*
 * @NOTE URL ID ROUTE MATCHER
 * */
export const UUID_REGEX = new RegExp(
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[45][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|WCG-[A-Z]-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9a-f]{32}|\d+)$/i,
);
